module.exports = __webpack_public_path__ + "img/tag_blank_back.7612883c.svg";